module.exports = __webpack_public_path__ + "static/favicon-913cc4ee29793231fbd1307521deedad.ico";